<template lang="pug">
  .btn-contain(v-bind:class="type")
    router-link(v-if="to" :to="to")
      .btn(v-bind:class="type") {{ text }}
    .btn(v-bind:class="type" v-else)
      .btn-text(v-if="!has_slot()") {{ text }}
      .btn-text(v-else)
        slot
</template>

<script>
export default {
  props: ['text','to', 'type'],
  methods: {
    has_slot (name = 'default') {
      return !!this.$slots[ name ] || !!this.$scopedSlots[ name ];
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-link,.btn-contain a {
    text-decoration:none;
  }
  .btn {
    display:block;
    padding: 0 14px;
    line-height:52px;
    height:52px;
    // text-align:center;
    background-color: $secondary;
    transition: background-color 200ms ease;
    background-repeat: no-repeat;
    background-position: center right 15px;
    background-size:16px;
    color:#eee;
    font-weight:600;
    margin-top:18px;
    cursor:pointer;
    text-decoration:none;
    * {
      text-decoration: none;
      color:#eee;
    }
    &.inline {
      display:inline-block;
      float:left;
    }
    &.m0 {
      margin:0;
    }
    &.mtop {
      margin-top:5px;
    }
    &.w {
      width:100%;
    }
    &.small-width {
      max-width:180px;
    }
    &.tiny-width {
      max-width:88px;
      line-height:40px;
      text-indent:0px;
      padding:0px;
      height:40px;
      text-align:center;
      font-size:12px;
    }
    &.outline {
      border:2px solid #fff;
      background:transparent;
      color:#fff;
      border-radius:5px;
      &:hover {
        background:#fff;
        * {
          color:#000;
        }
      }
    }
    &.small {
      line-height:44px;
    }
    &.center {
      text-align:center;
    }
    &.tiny {
      line-height:29px;
      font-size:13px;
      margin:0px;
      height:29px;
    }
    &.rounded {
      border-radius:14px;
    }
    &.rounded-small {
      border-radius:4px;
    }

    &.primary {
      background-color: $primary;
      &:hover {
        background-color: $primary-dark;
      }
    }

    &.secondary {
      background-color: $gradient-8;
      &:hover {
        background-color: $gradient-9;
      }
    }

    &.tertiary {
      background-color: $gradient-5;
      &:hover {
        background-color: $gradient-4;
      }
    }

    &.locked {
      background-color: #e44b4b;
      &:hover {
        background-color: #912e2e;
      }
    }
    
    &.lock {
      background-image: url('~@/assets/images/lock.svg');
    }

    &.tick {
      background-image: url('~@/assets/images/tick-white.svg');
    }

    &.arrow-left {
      background-image: url('~@/assets/images/arrow-left-white.svg');
    }

    &.arrow-right {
      background-image: url('~@/assets/images/arrow-right-white.svg');
    }

    &.notes {
      background-color: #c9ab60;
      &:hover {
        background-color: #a68c4a;
      }
      .btn-text {
        color:#302814;
      }
    }
    

    &.dark {
      background-color: $gradient-9;
      &:hover {
        background-color: $gradient-9;
      }
    }

    &.success {
      background-color: $tertiary;
      &:hover {
        background-color: $tertiary-dark;
      }
    }

    &:hover {
      background-color: $secondary-dark;
    }

  }
  .btn-disabled {
    background-color:$gradient-6;
    &:hover {
      background-color: $gradient-7;
    }
  }
</style>